export type RoleName =
  | 'orgAdmin'
  | 'orgAssistant'
  | 'orgUser'
  | 'workspaceOwner'
  | 'workspaceAdmin'
  | 'workspaceUser'
  | string

export const legacyRoleRank = {
  workspaceUser: 1,
  workspaceAdmin: 2,
  workspaceOwner: 3,
  orgUser: 4,
  orgAssistant: 5,
  orgAdmin: 7,
} as const

export type LegacyRoleName = keyof typeof legacyRoleRank

export function getRoleName(user: { roleName?: string | null; role?: { name?: string | null } | string | null }) {
  if (typeof user.role === 'string') return user.role
  return user.roleName ?? user.role?.name ?? undefined
}

export function hasRoleName(
  user: { roleName?: string | null; role?: { name?: string | null } | string | null },
  minimum: RoleName,
) {
  const name = getRoleName(user)
  if (!name) return false
  return (
    (legacyRoleRank[name as LegacyRoleName] ?? 0) >=
    (legacyRoleRank[minimum as LegacyRoleName] ?? Number.MAX_SAFE_INTEGER)
  )
}

export function isOrgRole(user: { roleName?: string | null; role?: { name?: string | null } | string | null }) {
  return hasRoleName(user, 'orgUser')
}

export function getLegacyRoleName(role: number) {
  return Object.entries(legacyRoleRank).find(([, value]) => value === role)?.[0]
}
